import { Button, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { useState } from 'react'

import { FaFileDownload } from 'react-icons/fa'
import { exportPDF } from 'features/claims/claimsApi'
import { getFileName } from 'utils/helper'

export const ViewEOB = (params: any) => {
  const [showModal, setShowModal] = useState(false)
  const [pdf, setPdf] = useState('' as any)

  const handleShowModal = () => {
    setShowModal(true)
    exportPDF(params.data.eobId).then((res: any) => {
      const blob = new Blob([res.data], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      setPdf(
        link.href +
          `#toolbar=1&navpanes=0&scrollbar=0&zoom=100%&view=fit&filename=${encodeURIComponent(
            getFileName(res.headers),
          )}`,
      )
    })
  }

  return (
    <Div>
      <ActionButton>
        <Button variant="secondary" size="small" width="70px" radius="normal" onClick={handleShowModal}>
          View
        </Button>
      </ActionButton>
      <ObModal
        show={showModal}
        close={() => setShowModal(false)}
        title="Explanation of Benefits"
        size="xl"
        customSize="full-width"
        height="auto"
      >
        <ModalContent>
          <embed src={pdf} width="100%" height="670" type="application/pdf"></embed>
        </ModalContent>
      </ObModal>
    </Div>
  )
}

export const EOBDownload = (params: any) => {
  const handelDownload = async () => {
    exportPDF(params.data.eobId).then((res: any) => {
      const blob = new Blob([res.data], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = getFileName(res.headers)
      link.click()
    })
  }
  return (
    <Div>
      <ActionButton>
        <Button variant="secondary" size="small" width="120px" radius="normal" onClick={handelDownload}>
          <FaFileDownload /> Download
        </Button>
      </ActionButton>
    </Div>
  )
}

const ActionButton = styled.div`
  display: flex;
`

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-family: ${({ theme }) => theme.fontFamily.milliard};
  font-style: normal;
  .custom-btn-close {
    font-size: 1.375rem !important;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    ${({ theme }) => theme.typography.m.normal};
    line-height: 1.125rem;
    background: none !important;
    border: none;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .modal-dialog-centered {
    max-width: 900px;
  }
`

const ModalContent = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  svg {
    font-size: 2.5rem;
    color: ${({ theme }) => theme.colors.tertiary.neutral};
    margin-bottom: 1rem;
  }
  .heading {
    font-size: 16px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.neutral.neutral};
  }
  .content {
    ${({ theme }) => theme.typography.m.normal};
  }
`
